import React, { createContext, useEffect, useState, useContext } from 'react';
import { saveLiveEvent, getLiveEvent } from '../services/liveevents';
import { AppContext } from './AppContext';
import {
  getFullTimeZone,
} from "../utils/utils";

const LiveEventsContext = createContext();

export const LiveEventsProvider = ({ children }) => {
  const [liveEvents, setLiveEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [updatedEvent, setUpdatedEvent] = useState(null);

  const { selectedClient } = useContext(AppContext);
  console.log("!!! SELECTED CLIENT IN LIVE EVENTS CONTEXT: ", selectedClient);

  useEffect(() => {
    console.log("!!! UPDATED EVENT CHANGED: ", updatedEvent);
  }, [updatedEvent]);

  const addLiveEvent = (event) => {
    setLiveEvents([...liveEvents, event]);
  };

  const removeLiveEvent = (eventId) => {
    setLiveEvents(liveEvents.filter(event => event.id !== eventId));
  };

  const saveUpdatedEvent = async () => {
    console.log("!!! SAVE UPDATED EVENT CALLED: ", updatedEvent);


    updatedEvent.published = updatedEvent.published ?? false;
    updatedEvent.timezone = getFullTimeZone()
    updatedEvent.open_date = updatedEvent.local_open_date;
    updatedEvent.start_date = updatedEvent.local_start_date;
    updatedEvent.recording_date = updatedEvent.local_recording_date;

    const newEvent = !updatedEvent.public_id;

    const liveEvent = await saveLiveEvent(updatedEvent, selectedClient.id);
    if (liveEvent) {
      if (newEvent) {
        const fetchedLiveEvent = await getLiveEvent(liveEvent.public_id, true);
        setSelectedEvent(fetchedLiveEvent);
        setUpdatedEvent(fetchedLiveEvent);
      }

      return liveEvent.public_id;
    }
  }

  function shallowDiff(obj1, obj2) {
    const diff = {};

    if (obj1 == null) {
      for (const key in obj2) {
        diff[key] = {
          from: null,
          to: obj2[key]
        };
      }
      return diff;
    } else if (obj2 == null) {
      for (const key in obj1) {
        diff[key] = {
          from: obj1[key],
          to: null
        };
      }
      return diff;
    }


    const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

    for (const key of allKeys) {
      if (obj1[key] !== obj2[key]) {
        diff[key] = {
          from: obj1[key],
          to: obj2[key]
        };
      }
    }

    return diff;
  }

  const canSaveEvent = () => {
    if (!updatedEvent || !updatedEvent.title) return false;


    // Remove image_data, local_open_date, local_recording_date, and local_start_date from the comparison since they are not part of the actual event object and are only used for handling date inputs
    const updatedEventCopy = { ...updatedEvent };

    delete updatedEventCopy.image_data;
    delete updatedEventCopy.local_open_date;
    delete updatedEventCopy.local_recording_date;
    delete updatedEventCopy.local_start_date;

    console.log("!!! SHALLOW DIFF: ", shallowDiff(selectedEvent, updatedEventCopy));


    return JSON.stringify(selectedEvent) !== JSON.stringify(updatedEventCopy);
  }

  return (
    <LiveEventsContext.Provider value={{ liveEvents, setLiveEvents, selectedEvent, setSelectedEvent, addLiveEvent, removeLiveEvent, updatedEvent, setUpdatedEvent, canSaveEvent, saveUpdatedEvent }}>
      {children}
    </LiveEventsContext.Provider>
  );
}

export const useLiveEvents = () => {
  return useContext(LiveEventsContext);
}

export default LiveEventsContext;
